import React, { useContext, useEffect, useRef, useState } from "react";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { Dialog } from "@headlessui/react";
import { CurrencyRupeeIcon, PaperAirplaneIcon, PencilSquareIcon, XMarkIcon } from "@heroicons/react/24/outline";
import LeadList from "./LeadList";
import axios from "axios";
import Select from "react-select";
import { DataContext } from "../../helper/HelperOne";
import { useLocation, useNavigate } from "react-router-dom";
import LabelTopView from "../Utility/LabelTopView";
import {
  CalendarDaysIcon,
  ChartBarBigIcon,
  ChartBarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  Search,
} from "lucide-react";
import UpdateConfirmation from "../Utility/UpdateConfirmation";
import { useToast } from "../../context/ToastProvider";
import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  AdjustmentsVerticalIcon,
} from "@heroicons/react/24/solid";
import { DevicePhoneMobileIcon } from "@heroicons/react/20/solid";
import { useExcelDownload, usePDFDownload } from "../../helper/HelperTwo";

function LeadCreate() {
  const userId = JSON.parse(localStorage.getItem("user"))?.id;
  const location = useLocation();
  const tabName = localStorage.getItem("tab_name");
  const {
    id_crypt,
    showForm,
    lead_id_crypt,
    unFollowedTypeOfWorkFilter,
    date_filter,
    throughdash,
    dashboard: dashboard,
  } = location.state || {};

  const { winflag } = location.state || {};
  const { custom_date_filter, custom_from_date, custom_to_date } =
    location.state || {};


  const [dashboardFlage, setDashboardFlage] = useState(dashboard || false);
  const leadStatusState = location?.state?.lead_win_status || "";
  const leadLossStatusState = location?.state?.lead_loss_status || "";

  const leadDateFilter = location?.state?.date_filter || "";
  const unfollow = location?.state?.unfollow || "";
  const future = location?.state?.date_filter || "";
  const formDate = location?.state?.from_date || "";
  const toDate = location?.state?.to_date || "";
  const futureLeads = location?.state?.futureLeads || "";
  const totalLeads = location?.state?.totalLeads || "";
  const salesService = location?.state?.salesService || "";

  const [previewImages, setPreviewImages] = useState(null);
  const [existingImages, setExistingImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [lead, setLead] = useState(false);
  // const [typeOfWorkFilter, setTypeOfWorkFilter] = useState(throughdash ? true : false);
  const [triggerFromDashboard, setTriggerFromDashboard] = useState(
    throughdash || false
  );

  const [unfollowStatus, setUnfollowStatus] = useState(false);
  const [leadStatusFromState, setLeadStatus] = useState(leadStatusState || "");
  const [leadLossStatusFromState, setLeadLossStatusFromState] = useState(
    leadLossStatusState || ""
  );
  const { PDFDownload } = usePDFDownload();
  const { excelDownload } = useExcelDownload();
  const navigate = useNavigate();
  const { triggerToast } = useToast();
  const user = JSON.parse(localStorage.getItem("user"));
  const [apiError, setApiError] = useState(false);

  const [filterParams, setFilterParams] = useState("");
  const submitBtnRef = useRef(null);
  const { searchData } = useContext(DataContext);
  const [isEditing, setIsEditing] = useState(false);
  const [openDialogBoxForLead, setOpenDialogBoxForLead] = useState(
    dashboardFlage ? true : false
  );
  const [saveBtn, setSaveBtn] = useState("save");
  const [saveBtnOpen, setSaveBtnOpen] = useState(dashboardFlage ? true : false);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState("");
  const [editLeadIdCrypty, setEditLeadIdCrypty] = useState("");
  const [leadAllDatas, setLeadAllDatas] = useState([]);
  const [leadPaginationData, setLeadPaginationData] = useState([]);
  const [leadStats, setLeadStats] = useState({});
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [stats, setStats] = useState([]);
  const [typeOfWork, setTypeOfWork] = useState([]);
  const [advertisementMode, setAdvertisementMode] = useState([]);
  const [lossReason, setLossReason] = useState([]);
  const [cities, setCities] = useState([]);
  const [leadDiscussion, setLeadDiscussion] = useState(false);
  const [lastSyncDate, setLastSyncDate] = useState(null);
  const [workersData, setWorkersData] = useState([]);
  const [salesmanData, setSalesmanData] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [image, setImage] = useState(null);
  const [projectManagerList, setProjectManagerList] = useState([]);
  // const [filters, setFilters] = useState({
  //   date_filter: future || "",
  //   // date_from: future ? new Date(Date.now() + 86400000).toISOString().split("T")[0] : "" || formDate,
  //   date_from:  formDate || "",
  //   date_to:  toDate || "",
  //   create_date_filter: "",
  //   create_date_from: "",
  //   create_date_to: "",
  // });

  const [filters, setFilters] = useState({
    date_filter: custom_date_filter || future || "", // Use custom filter if exists, else future, else empty
    date_from: custom_from_date || formDate || "", // Use custom from date if exists, else formDate
    date_to: custom_to_date || toDate || "", // Use custom to date if exists, else toDate

    create_date_filter: "",
    create_date_from: "",
    create_date_to: "",
  });

  const [currentPage, setCurrentPage] = useState(1);

  const typeOfWorkId =
    typeOfWork
      ?.filter((work) => work.name === unFollowedTypeOfWorkFilter) // filter returns array
      .map((work) => work.name) || [];

  const [leadDetails, setLeadDetails] = useState({
    customer_name: "",
    contact_no: "",
    contact_person: "",
    contact_person_no: "",
    advertisement_mode_id: "",
    sales_service: "",
    city: "",
    address: "",
    lead_status: "",
    followup_date: "",
    worker_tally_id: "",
    worker_name: "",
    salesman_tally_id: "",
    salesman_name: "",
    project_manager: "",
    type_of_work: [],
    comments: "",
    images: [],
    loss_reason: "",
    priority: "",
    location: "",
  });

  const [requiredFields, setRequiredFields] = useState({
    customer_name: "",
    contact_no: "",
    contact_person: "",
    contact_person_no: "",
    advertisement_mode_id: "",
    sales_service: "",
    address: "",
    city: "",
    type_of_work: [],
    comments: "",
  });

  const [searchFilterData, setSearchFilterData] = useState({
    customer_name: "",
    contact_no: "",
    contact_person: "",
  });

  const [leadPhoneData, setLeadPhoneData] = useState(null);

  const [leadPhoneDataFlag, setLeadPhoneDataFlag] = useState(false);
  const [topFilter, setTopFilter] = useState({
    worker_tally_id: "",
    // type_of_work:  "",
    type_of_work: unFollowedTypeOfWorkFilter
      ? unFollowedTypeOfWorkFilter
      : "" || "",
    sales_service: salesService || tabName || "",
    lead_status: future ? "followup" : "",
    project_manager: "",
  });

  const [priority, setPriority] = useState([]);
  const [partyName, setPartyName] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Convert name to id
  useEffect(() => {
    if (typeOfWork?.length && unFollowedTypeOfWorkFilter) {
      const selectedTypeOfWork = typeOfWork
        .filter((work) => work.name === unFollowedTypeOfWorkFilter)
        .map((work) => work.id);

      setLeadDetails((prev) => ({
        ...prev,
        type_of_work: selectedTypeOfWork[0] || "", // single select, take first id
      }));

      setTopFilter((prev) => ({
        ...prev,
        type_of_work: selectedTypeOfWork[0] || "",
      }));
    }
  }, [typeOfWork, unFollowedTypeOfWorkFilter]);

  // useEffect(() => {
  //   if (triggerFromDashboard && topFilter.type_of_work) {
  //     const fakeEvent = { preventDefault: () => {} };
  //     handleSubmitFilter(fakeEvent);

  //     // ✅ Run only once — prevent future auto triggers
  //     setTriggerFromDashboard(false);
  //   }
  // }, [triggerFromDashboard]);

  useEffect(() => {
    if (topFilter.type_of_work && triggerFromDashboard) {
      // Create a fake event object for e.preventDefault
      const fakeEvent = { preventDefault: () => { } };
      // handleSubmitCustomFilter(fakeEvent);
      handleSubmitFilter(fakeEvent);
    }
  }, [topFilter.type_of_work]);

  // useEffect(() => {
  //   if (throughdashboard) {
  //     // Create a fake event object for e.preventDefault
  //     const fakeEvent = { preventDefault: () => {} };
  //     // handleSubmitCustomFilter(fakeEvent);
  //     handleSubmitFilter(fakeEvent);
  //   }
  // }, [throughdashboard]);

  // useEffect(() => {
  //   if (!typeOfWorkFilter) {
  //     // Create a fake event object for e.preventDefault
  //     const fakeEvent = { preventDefault: () => {} };
  //     // handleSubmitCustomFilter(fakeEvent);
  //     handleSubmitFilter(fakeEvent);
  //   }
  // }, []);

  useEffect(() => {
    if (date_filter || formDate || toDate) {
      // Create a fake event object for e.preventDefault
      const fakeEvent = { preventDefault: () => { } };
      handleSubmitFilter(fakeEvent);
    }
  }, [date_filter, formDate, toDate]);

  const leadStatus = [
    {
      id: "win",
      label: "Win",
    },
    {
      id: "loss",
      label: "Lost",
    },
    {
      id: "followup",
      label: "Followup",
    },
  ];

  const salesServiceOptions = [
    {
      value: "sales",
      name: "Sales",
    },
    {
      value: "service",
      name: "Service",
    },
  ];

  const statusOptions = [
    {
      value: "win",
      name: "Win",
    },
    {
      value: "loss",
      name: "Lost",
    },
    {
      value: "followup",
      name: "Follow Up",
    },
  ];

  // const quotationLead = async()=>{

  // }

  const quotationLead = async (lead_id_crypt) => {
    // setLoading(true);

    setIsEditing(true);
    setSaveBtnOpen(false);
    // setEditLeadIdCrypty(id_crypt);
    setOpenDialogBoxForLead(true);
    // setSaveBtn("update");
    setRequiredFields({
      customer_name: "",
      contact_no: "",
      type_of_work: [],
      sales_service: "",
    });
    setEditId(id_crypt);
    try {
      const response = await axios.get(`public/api/leads/${lead_id_crypt}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      // setDiscussionData(response?.data);

      // setDiscussionData(response?.data);

      // setDiscussion((prev) => ({
      //   ...prev,
      //   status: response?.data?.customer_name,
      // }));


      setLeadDetails((prev) => ({
        ...prev,
        customer_name: response?.data.customer_name,
        contact_no: response?.data.contact_no,
        contact_person: response?.data.contact_person,
        contact_person_no: response?.data.contact_person_no,
        advertisement_mode_id: response?.data.advertisement_mode_id,
        sales_service: response?.data.sales_service,
        worker_tally_id: response?.data.worker_tally_id,
        worker_name: response?.data.worker_name,
        salesman_tally_id: response?.data.salesman_tally_id,
        salesman_name: response?.data.salesman_name,
        project_manager: response?.data.project_manager,
        followup_date: response?.data.followup_date,
        lead_status: response?.data.lead_status,
        loss_reason: response?.data.loss_reason?.id,
        city: response?.data.city,
        address: response?.data.address,
        type_of_work: response?.data?.type_of_work?.map((item) => item.name),
        comments: response?.data?.comments,
        priority: response?.data?.priority,
        location: response?.data?.location,
        images: [],
      }));
      // setExistingImages(response?.data?.lead_images || []);
      // setDeletedImages([]);
      // setPreviewImages(response?.data?.lead_images?.map((item) => item.image));


    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        triggerToast("error", error.response?.data?.message, "error");
      }

      // toast.error(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (lead_id_crypt) {
      quotationLead(lead_id_crypt);

    }
  }, [lead_id_crypt]);

  const LeadDatas = async (page = 1) => {
    try {
      setLoading(true);
      let url = `public/api/leads?page=${page}&sales_service=${tabName}`;


      const leadUrl = url;

      const response = await axios.get(leadUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setStats(response.data);
      setLeadAllDatas(response.data.leads.data);
      setLeadPaginationData(response.data.leads);
      setLastSyncDate(response.data.lastSync);
    } catch (error) {
      if (error.response?.status === 500) {
        setApiError(true); // Show reload button
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (lead) {
      LeadDatas();
    }
  }, [lead]);

  useEffect(() => {
    if (location?.state?.unfollow) {
      setUnfollowStatus(true);
      if (location?.state?.date_filter == "today") {
        setTopFilter((prev) => ({
          ...prev,
          lead_status: "followup",
        }));
      }
    }

    if (leadStatusFromState) {
      setTopFilter((prev) => ({
        ...prev,
        lead_status: leadStatusFromState,
      }));
    }

    if (leadLossStatusFromState) {
      setTopFilter((prev) => ({
        ...prev,
        lead_status: leadLossStatusFromState,
      }));
    }

    if (leadDateFilter) {
      setFilters((prev) => ({
        ...prev,
        date_filter: leadDateFilter,
      }));
      // if (unfollow) {
      // }
    }
  }, [
    location.state?.unfollow,
    leadStatusFromState,
    leadLossStatusFromState,
    leadDateFilter,
  ]);

  useEffect(() => {
    // Only submit if there is a value to filter
    if (
      winflag === true ||
      topFilter.lead_status ||
      filters.date_filter ||
      filters.unfollow
    ) {
      fetchLeadDatas(1);
      // fetchLeadOnly(1); // pass current topFilter & filters
    }
  }, [winflag]);

  // useEffect(() => {
  // Only submit if there is a value to filter
  // if (
  //   (winflag === false && topFilter.lead_status) ||
  //   filters.date_filter ||
  //   filters.unfollow
  // ) {
  //   handleSubmitFilter(1, topFilter, filters); // pass current topFilter & filters
  // }
  // }, [topFilter]);

  const fetchLeadOnly = async (currentPage) => {
    try {
      setLoading(true); // start loader
      setApiError(false); // reset error state

      const queryParams = new URLSearchParams();

      // Object.entries({ ...topFilter, ...filters }).forEach(([key, value]) => {
      //   queryParams.append(key, value ?? ""); // ensures empty string stays
      // });
      Object.entries({
        ...topFilter,
        ...filters,
        page: currentPage,
      }).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          queryParams.append(key, value);
        }
      });

      // Construct API URL with filters and pagination
      let url = `public/api/leads?${queryParams.toString()}`;
      if (unfollow) {
        url = `public/api/leads?page=${currentPage.toString()}&unfollow=${unfollow}&date_filter=${future}&date_from=${filters?.date_from
          }&date_to=${filters?.date_to}&sales_service=${salesService}`;
      }
      if (leadStatusFromState) {
        url = `public/api/leads?page=${currentPage.toString()}&lead_status=${leadStatusFromState}&date_filter=${location?.state?.date_filter
          }&date_from=${filters?.date_from}&date_to=${filters?.date_to
          }&type_of_work=${topFilter?.type_of_work
          }&sales_service=${salesService}`;
      }
      if (leadLossStatusFromState) {
        url = `public/api/leads?page=${currentPage.toString()}&lead_status=${leadLossStatusFromState}&date_filter=${future}&date_from=${filters?.date_from
          }&date_to=${filters?.date_to}&type_of_work=${topFilter?.type_of_work
          }&sales_service=${salesService}`;
      }
      // if (leadDateFilter) {
      //   url = `public/api/leads?page=${currentPage.toString()}&date_filter=${leadDateFilter}`;
      // }
      if (futureLeads) {
        url = `public/api/leads?page=${currentPage.toString()}&date_filter=${future}&date_from=${filters?.date_from
          }&sales_service=${salesService}`;
      }

      // if (topFilter.sales_service) {
      //   url = `public/api/leads?page=${currentPage.toString()}&sales_service=${
      //     topFilter.sales_service
      //   }`;
      // } if (filters.worker_tally_id) {
      //   url = `public/api/leads?page=${currentPage.toString()}&worker_tally_id=${
      //     filters.worker_tally_id
      //   }`;
      // }

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setLeadStats(response.data.stats);

      setLeadPaginationData(response.data.leads);
      setStats(response.data);
      // setLeadAllDatas(response.data.leads.data);
      setLastSyncDate(response.data.lastSync);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        console.error("Error fetching lead data: ", error);

        if (error.response?.status === 500) {
          setApiError(true); // show reload button
        }
      }
    } finally {
      setLoading(false); // stop loader
    }
  };

  // const fetchLeadAllDatas = async (page = 1) => {
  // try {
  //      let url = `public/api/leads`;
  //     const leadUrl = url;
  //     const response = await axios.get(leadUrl, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     });
  //     setLeadAllDatas(response.data.leads.data);
  //     setLeadPaginationData(response.data.leads);
  //   } catch (error) {


  //   }
  // };

  useEffect(() => {
    if (!leadStatusFromState && !leadLossStatusFromState && !leadDateFilter) {
      fetchLeadOnly(currentPage);
    }
  }, [currentPage]);

  const fetchLeadDatas = async (page = 1) => {
    try {
      await fetchLeadOnly(1);
      // Fetch type of work data
      const typeOfWorkResponse = await axios.get(
        `public/api/type-of-works/list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setTypeOfWork(typeOfWorkResponse.data);

      const advertisementModeResponse = await axios.get(
        `public/api/advertisement-mode/list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setAdvertisementMode(advertisementModeResponse.data);

      const lossReasonResponse = await axios.get(
        `public/api/loss-reasons/list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setLossReason(lossReasonResponse.data);

      const workersResponse = await axios.get(`public/api/workers/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setWorkersData(workersResponse.data);

      const salesmanResponse = await axios.get(`public/api/salesmen/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setSalesmanData(salesmanResponse.data);

      const salesResponse = await axios.get(`public/api/salesmen/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setSalesData(salesResponse.data);

      const citiesResponse = await axios.get(`public/api/cities/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setCities(citiesResponse.data);

      const projectManagerResponse = await axios.get(
        `public/api/project-manager/list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setProjectManagerList(projectManagerResponse?.data);

      const priorityResponse = await axios.get(`public/api/priorities/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setPriority(priorityResponse?.data);

    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        console.error("Error fetching lead data: ", error);
        if (error.response?.status === 500) {
          setApiError(true); // Show reload button
        }
      }
    }
  };

  useEffect(() => {
    if (!leadStatusFromState && !leadLossStatusFromState && !leadDateFilter) {
      fetchLeadDatas();
    }
  }, []);

  const searchLead = async (searchData) => {
    try {
      const page = 1;
      const token = localStorage.getItem("token");

      const queryParams = new URLSearchParams({
        page,
        search: searchData,
        ...searchFilterData,
      });

      const leadUrl = `public/api/leads?${queryParams.toString()}`;

      const response = await axios.get(leadUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const { leads, lastSync } = response.data;

      setStats(response.data);
      setLeadAllDatas(leads.data);
      setLeadPaginationData(leads);
      setLastSyncDate(lastSync);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        console.error("Error fetching lead data:", error);
      }
    }
  };

  useEffect(() => {
    if (!leadStatusFromState && !leadLossStatusFromState && !leadDateFilter) {
      searchLead(searchData);
    }
  }, [searchData]);

  const handleAddLead = async () => {
    setLoading(true);
    setOpenDialogBoxForLead(true);
    setIsEditing(false);
    setSaveBtnOpen(true);
    setSaveBtn("save");
    setLeadDetails({
      customer_name: "",
      contact_no: "",
      contact_person: "",
      contact_person_no: "",
      advertisement_mode_id: 7,
      sales_service: "",
      // country: "",
      // state: "",
      city: "SIVAKASI",
      address: "",
      // pincode: "",
      type_of_work: [],
      comments: "",
      priority: "",
      location: "",
    });

    setRequiredFields({
      customer_name: "",
      contact_no: "",
      type_of_work: [],
    });

    setLoading(false);
  };

  const handleChangeForLead = (e) => {
    const { name, value, worker, salesman } = e.target;

    // For phone number special case (optional)
    // if (name === "contact_no" && value.length >= 10) {
    //   let phone = value.replace(/\D/g, "");
    //   handleChangePhone(phone);
    // }

    setLeadDetails((prev) => {
      if (name === "lead_status") {
        return {
          ...prev,
          lead_status: value,
          loss_reason: "", // reset or prepare loss_reason field
        };
      }

      if (name === "worker_tally_id") {
        return {
          ...prev,
          worker_tally_id: value,
          worker_name: worker || "",
        };
      }

      if (name === "salesman_tally_id") {
        return {
          ...prev,
          salesman_tally_id: value,
          salesman_name: salesman || "",
        };
      }

      // Default case for other fields
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleChangeForPartyName = async (e) => {
    const { name, value } = e.target;

    setLeadDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (!value) {
      setPartyName([]);
      setShowSuggestions(false);
      return;
    }

    try {
      const response = await axios.get(
        `public/api/customers/suggestions?search=${value}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
        console.log(response)
      setPartyName(response?.data || []);
      setShowSuggestions(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectSuggestion = (item) => {
    console.log(item)
  setLeadDetails((prev) => ({
  ...prev,
  customer_name: item?.ledger_name || "",
  contact_no: item?.primary_mobile_no || "",
  address: [
    item?.address_line_1,
    item?.address_line_2 || "-",
    item?.address_line_3
  ]
    .filter(Boolean)
    .join(", "),
    // contact_person: item?.contact_name || "",
}));


    setPartyName([]);
    setShowSuggestions(false);
  };



  // const handleChangeForLeadImages = (e) => {
  //   const files = Array.from(e.target.files);

  //   // Generate preview URLs
  //   const previews = files.map((file) => URL.createObjectURL(file));

  //   setPreviewImages((prev) => [...(prev || []), ...previews]); // fallback []
  //   setLeadDetails((prev) => ({
  //     ...prev,
  //     images: [...(prev.images || []), ...files], // fallback []
  //   }));
  // };

  const handleChangeForLeadImages = (e) => {
    const files = Array.from(e.target.files);

    setLeadDetails((prev) => ({
      ...prev,
      images: [...(Array.isArray(prev.images) ? prev.images : []), ...files],
    }));
  };

  // const handleRemoveImage = (index) => {
  //   setPreviewImages((prev) => prev.filter((_, i) => i !== index));
  //   setLeadDetails((prev) => ({
  //     ...prev,
  //     images: prev.images.filter((_, i) => i !== index),
  //   }));
  // };

  const handleRemoveImage = (index, isExisting = false) => {
    if (isExisting) {
      // Removing existing DB image
      const imgToDelete = existingImages[index];
      setDeletedImages((prev) => [...prev, imgToDelete.id]); // mark for backend delete
      setExistingImages(existingImages.filter((_, i) => i !== index));
    } else {
      // Removing new uploaded image
      setLeadDetails((prev) => ({
        ...prev,
        images: prev.images.filter((_, i) => i !== index),
      }));
    }
  };

  const handleChangePhone = async (phone) => {


    try {
      const response = await axios.get("public/api/customers/phone", {
        params: { phone },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      console.log(response)
      if (response.data && Object.keys(response.data).length > 0) {
        setLeadPhoneData(response.data);

        setLeadDetails({
          customer_name: response?.data?.ledger_name,
          contact_no: phone,
          contact_person: leadDetails.contact_person,
          contact_person_no: leadDetails.contact_person_no,
          advertisement_mode_id: leadDetails.advertisement_mode_id,
          sales_service: leadDetails.sales_service,

          // country: response?.data?.country,
          // state: response?.data?.state,
          city: response?.data?.address_line_3,
          address:
            (response?.data?.address_line_1 || "") +
            (response?.data?.address_line_2
              ? " " + response.data.address_line_2
              : ""),
          // pincode: response?.data?.pin_code,
          type_of_work: leadDetails.type_of_work,
          comments: leadDetails.comments,
        });
      } else {
        setLeadDetails({
          customer_name: leadDetails.customer_name,
          contact_no: phone,
          contact_person: leadDetails.contact_person,
          contact_person_no: leadDetails.contact_person_no,
          advertisement_mode_id: leadDetails.advertisement_mode_id,
          sales_service: leadDetails.sales_service,

          // country: leadDetails.country,
          // state: leadDetails.state,
          city: leadDetails.city,
          address: leadDetails.address,
          // pincode: leadDetails.pincode,
          type_of_work: leadDetails.type_of_work,
          comments: leadDetails.comments,
        });
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        triggerToast("error", error.response.data.message, "error");
      }
      // toast.error(error.response.data.message);
    }
  };

  const handleSubmitForLead = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("customer_name", leadDetails.customer_name || "");
    formData.append("contact_no", leadDetails.contact_no || "");
    formData.append("contact_person", leadDetails.contact_person || "");
    formData.append("contact_person_no", leadDetails.contact_person_no || "");
    formData.append(
      "advertisement_mode_id",
      leadDetails.advertisement_mode_id || ""
    );
    formData.append("sales_service", leadDetails.sales_service || "");
    formData.append("lead_status", leadDetails.lead_status || "");
    formData.append("followup_date", leadDetails.followup_date || "");
    formData.append("country", leadDetails.country || "");
    formData.append("state", leadDetails.state || "");
    formData.append("city", leadDetails.city || "");
    formData.append("address", leadDetails.address || "");
    formData.append("pincode", leadDetails.pincode || "");
    formData.append("loss_reason", leadDetails.loss_reason || "");
    formData.append("project_manager", leadDetails.project_manager || "");

    (leadDetails.type_of_work || []).forEach((work, index) => {
      formData.append(`type_of_work[${index}]`, work);
    });

    formData.append("worker_tally_id", leadDetails.worker_tally_id || "");
    formData.append("worker_name", leadDetails.worker_name || "");
    formData.append("salesman_tally_id", leadDetails.salesman_tally_id || "");
    formData.append("salesman_name", leadDetails.salesman_name || "");

    formData.append("comments", leadDetails.comments || "");
    formData.append("priority", leadDetails.priority || "");
    formData.append("location", leadDetails.location || "");

    // formData.append("images", leadDetails.images);
    leadDetails.images?.forEach((file) => {
      formData.append("images[]", file);
    });

    try {
      const response = await axios.post("public/api/leads", formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      triggerToast("Success", response.data.message, "success");
      setOpenDialogBoxForLead(false);
      setPreviewImages(null);
      await fetchLeadOnly();
    } catch (error) {

      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else if (error?.response?.status === 422) {
        triggerToast(
          "Warning",
          error?.response?.data?.message || "Submit failed",
          "warning"
        );
        setRequiredFields(error.response.data.errors);
      } else {
        console.error("Submit error:", error);
        triggerToast(
          "Error",
          error?.response?.data?.message || "Submit failed",
          "error"
        );

        if (error?.response?.data?.errors) {
          setRequiredFields(error.response.data.errors);
        }
      }
    }
  };

  const handleEditForLead = async (id_crypt) => {
    setIsEditing(false);

    setSaveBtnOpen(true);
    setRequiredFields({
      customer_name: "",
      contact_no: "",
      type_of_work: [],
      sales_service: "",
    });
    setSaveBtn("update");
    // try {
    //   const response = await axios.get(`public/api/leads/${id_crypt}`, {
    //     headers: {
    //       Authorization: `Bearer ${localStorage.getItem("token")}`,
    //     },
    //   });

    //   // toast.success("Now You Can Edit This Lead");

    //   setLeadDetails({
    //     customer_name: response?.data?.customer_name,
    //     contact_no: response?.data?.contact_no,
    //     contact_person: response?.data?.contact_person,
    //     contact_person_no: response?.data?.contact_person_no,
    //     advertisement_mode_id: response?.data?.advertisement_mode_id,
    //     sales_service: response?.data?.sales_service,
    //     // country: response?.data?.country,
    //     // state: response?.data?.state,
    //     city: response?.data?.city,
    //     address: response?.data?.address,
    //     // pincode: response?.data?.pincode,
    //     type_of_work: response?.data?.type_of_work?.map((item) => item.name),
    //     comments: response?.data?.comments,
    //   });
    // } catch (error) {
    //   triggerToast("error", error.response.data.message, "error");
    //   // toast.error(error.response.data.message);
    // } finally {
    //   setLoading(false);
    // }
  };

  const handleDialogClose = async () => {
    setLoading(true);
    setIsEditing(false);
    setOpenDialogBoxForLead(false);
    setPreviewImages(null);
    setDashboardFlage(false);
    setLeadPhoneData(null);
    setLeadPhoneDataFlag(false);

    setRequiredFields({
      customer_name: "",
      contact_no: "",
      type_of_work: [],
      sales_service: "",
    });
    try {
      // await fetchLeadDatas();
      await fetchLeadOnly();

      if (showForm) {
        navigate("/crm/lead_dashboard"); // Redirect to Dashboard
      } else {
        navigate(location.pathname, {
          state: { ...location.state, showForm: false },
        });
      }
      navigate(".", { state: { ...location.state, dashboard: false } });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const workers = workersData?.map((worker) => ({
    id: worker.worker_tally_id,
    name: worker?.name,
  }));

  const salesMan = salesData?.map((sales) => ({
    id: sales.salesman_tally_id,
    name: sales?.name,
  }));

  const projectManager = projectManagerList?.map((sales) => ({
    id: sales.id,
    name: sales?.name,
  }));

  const handleChangeForLeadFilter = (e) => {
    const { name, value } = e.target;

    if (name === "type_of_work" && value) {
      setTriggerFromDashboard(false);
    }

    setTopFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => {
      const updated = { ...prev, [name]: value };

      // If po_date is changed and not 'custom', clear from/to
      if (name === "date_filter" && value !== "custom") {
        updated.date_from = "";
        updated.date_to = "";
      }

      return updated;
    });
  };

  const handleSubmitFilter = async (page = 1) => {
    try {
      setLoading(true);

      const queryParams = new URLSearchParams();

      Object.entries({
        ...topFilter,
        ...filters,
        // page: currentPage.toString(),
      }).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          queryParams.append(key, value);
        }
      });

      const leadUrl = `public/api/leads?${queryParams.toString()}`;

      const response = await axios.get(leadUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const { leads, lastSync } = response.data;

      setStats(response.data);
      setLeadAllDatas(leads?.data || []);
      setLeadPaginationData(leads || {});
      setLastSyncDate(lastSync || null);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        console.error("Error fetching filtered leads:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitCustomFilter = async (e) => {
    e.preventDefault(); // prevent default form submission behavior if used in a form

    const { custom_date_filter, custom_from_date, custom_to_date } =
      location.state || {};

    try {
      setLoading(true);

      // Build query params based on available custom filters
      const queryParams = new URLSearchParams();

      if (custom_date_filter)
        queryParams.append("custom_date_filter", custom_date_filter);
      if (custom_from_date)
        queryParams.append("custom_from_date", custom_from_date);
      if (custom_to_date) queryParams.append("custom_to_date", custom_to_date);

      // If you also have topFilter or other filters, merge them here:
      Object.entries(topFilter || {}).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          queryParams.append(key, value);
        }
      });

      const leadUrl = `public/api/leads?${queryParams.toString()}`;

      const response = await axios.get(leadUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const { leads, lastSync } = response.data;

      setStats(response.data);
      setLeadAllDatas(leads?.data || []);
      setLeadPaginationData(leads || {});
      setLastSyncDate(lastSync || null);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        console.error("Error fetching filtered leads:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResetTopFilter = async () => {
    setLeadStatus("");

    // setUnfollowStatus(false); // use only if needed locally
    // setLead(true);

    setTopFilter({
      worker_tally_id: "",
      salesman_tally_id: "",
      lead_status: "",
      type_of_work: "",
      project_manager: "",
      sales_service: tabName || ""
    });

    setFilters({
      date_filter: "",
      date_from: "",
      date_to: "",
      create_date_filter: "",
      create_date_from: "",
      create_date_to: "",
    });

    await LeadDatas();
    // await fetchLeadOnly(1);

    // Fetch data
    // await fetchLeadDatas();
    // await fetchLeadAllDatas();

    // 👇 Correctly reset state and optionally replace history
    navigate(location.pathname, {
      replace: true,
      state: { unfollow: false },
    });
  };

  const handleDownloadPDF = () => {
    const params = {
      date_from: filters.date_from || "",
      date_to: filters.date_to || "",
      date_filter: filters.date_filter || "",

      create_date_from: filters.create_date_from || "",
      create_date_to: filters.create_date_to || "",
      create_date_filter: filters.create_date_filter || "",

      type_of_work: topFilter.type_of_work || "",
      project_manager: topFilter.project_manager || "",
      lead_status: topFilter.lead_status || "",
      worker_tally_id: topFilter.worker_tally_id || "",
      salesman_tally_id: topFilter.salesman_tally_id || "",
      sales_service: topFilter.sales_service || "",
    };

    PDFDownload("leads", "leads.pdf", params, setLoading);
  };
  const handleDownloadExcel = () => {
    const params = {
      date_from: filters.date_from || "",
      date_to: filters.date_to || "",
      date_filter: filters.date_filter || "",

      create_date_from: filters.create_date_from || "",
      create_date_to: filters.create_date_to || "",
      create_date_filter: filters.create_date_filter || "",

      type_of_work: topFilter.type_of_work || "",
      project_manager: topFilter.project_manager || "",
      lead_status: topFilter.lead_status || "",
      worker_tally_id: topFilter.worker_tally_id || "",
      salesman_tally_id: topFilter.salesman_tally_id || "",
      sales_service: topFilter.sales_service || "",
    };


    excelDownload("leads", "leads.xlsx", params, setLoading);
  };

  return (
    <>
      {loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : apiError ? (
        <div className="h-screen bg-white flex flex-col justify-center items-center">
          <p className="mb-4 text-red-600 font-medium">Something went wrong.</p>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            onClick={() => {
              setApiError(false); // hide error while retrying
              fetchLeadOnly(); // retry API
            }}
          >
            Reload
          </button>
        </div>
      ) : (
        <>
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
            <div className="flex-1">
              <LabelTopView label="Leads Overview" icon={<ChartBarBigIcon />} />
            </div>

            {/* <div className="bg-white shadow-md rounded-xl p-4 border border-gray-200">
              <div className="text-gray-600 text-sm font-medium flex items-center gap-2">
                <span className="text-md">🕒</span> Last Sync @
                <span className="text-indigo-600 italic text-md">
                  {lastSyncDate ? lastSyncDate : "Not synced yet"}
                </span>
              </div>
            </div> */}
          </div>

          {/* <div className="grid">
            <div className="shadow-sm">
              <div className="grid  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 ">
                {(userId === 1 || userId === 2) && (
                  <div className="flex flex-col items-right justify-right p-6 m-2 bg-indigo-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                    <div className="flex items-center gap-4">
                      <div className="p-3 bg-indigo-200 rounded-full">
                        <AdjustmentsVerticalIcon className="h-6 w-6  text-indigo-700" />
                      </div>
                      <div>
                        <div className="text-gray-500 font-medium text-md ">
                          Total Leads
                        </div>
                        <div className="text-indigo-900 font-bold text-2xl">
                          {leadStats?.totalLeads}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
          
                <div className="flex flex-col items-right justify-right p-6 m-2 bg-yellow-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-yellow-200 rounded-full">
                      <AdjustmentsVerticalIcon className="h-6 w-6  text-yellow-700" />
                    </div>
                    <div>
                      <div className="text-gray-500 font-medium text-md ">
                        Today Leads
                      </div>
                      <div className="text-yellow-900 font-bold text-2xl">
                        {leadStats?.todayLeads}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-orange-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-orange-200 rounded-full">
                      <ClockIcon className="h-6 w-6  text-orange-700" />
                    </div>
                    <div>
                      <div className="text-gray-500 font-medium text-md ">
                        UnFollow-up Leads
                      </div>
                      <div className="text-orange-900 font-bold text-2xl">
                        {leadStats?.unfollowLeads}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-blue-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-blue-200 rounded-full">
                      <ClockIcon className="h-6 w-6  text-blue-700" />
                    </div>
                    <div>
                      <div className="text-gray-500 font-medium text-md ">
                        Future Leads
                      </div>
                      <div className="text-blue-900 font-bold text-2xl">
                        {leadStats?.futureLeads}
                      </div>
                    </div>
                  </div>
                </div>

                {(userId === 1 || userId === 2) && (
                  <>
                   
                    <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-green-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                      <div className="flex items-center gap-4">
                        <div className="p-3 bg-green-200 rounded-full">
                          <CheckCircleIcon className="h-6 w-6  text-green-700" />
                        </div>

                        <div>
                          <div className="text-gray-500 font-medium text-md ">
                            Win Leads
                          </div>
                          <div className="text-green-900 font-bold text-2xl">
                            {leadStats?.totalWinLeads}
                          </div>
                        </div>
                      </div>
                    </div>

                 
                    <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-red-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                      <div className="flex items-center gap-4">
                        <div className="p-3 bg-red-200 rounded-full">
                          <XCircleIcon className="h-6 w-6  text-red-700" />
                        </div>
                        <div>
                          <div className="text-gray-500 font-medium text-md ">
                            Lost Leads
                          </div>
                          <div className="text-red-900 font-bold text-2xl">
                            {leadStats?.totalLostLeads}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div> */}

          <div className="mt-6 overflow-x-auto  rounded-lg shadow-sm border border-gray-300 p-2">
            <table className="table-auto p-5 w-full ">
              <tbody>
                {/* TOTAL QUOTATIONS */}
                {(userId == 1 || userId == 2) && (
                  <>
                    <tr className="bg-gradient-to-r cursor-pointer from-purple-100 to-purple-50 border border-purple-200 rounded-md shadow mb-2">
                      <td className="flex items-center p-3 text-purple-800 font-semibold rounded-l-md">
                        <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-purple-200 text-purple-600 mr-2 rotate-[-90deg]" />
                        Total Lead
                      </td>
                      <td
                        className="text-[20px] font-bold text-purple-700 text-right p-3"
                        id="total-quotations"
                      >
                        {leadStats?.totalLeads || "0"}
                      </td>

                    </tr>

                    <tr className="bg-gradient-to-r cursor-pointer from-green-100 to-green-50 text-green-700 border border-green-200 rounded-md shadow mb-2">
                      <td className="flex items-center p-2 col-span-2 font-semibold">
                        <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-green-200 text-green-600 mr-2 rotate-[-90deg]" />
                        Win Leads
                      </td>
                      <td className="text-[20px] font-semibold text-right p-2">
                        {leadStats?.totalWinLeads}
                      </td>


                    </tr>
                    <tr className="bg-gradient-to-r cursor-pointer from-red-100 to-red-50 text-red-800 border border-red-200 rounded-md shadow mb-2">
                      <td className="flex items-center p-2 col-span-2 font-semibold">
                        <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-red-200 text-red-600 mr-2 rotate-[-90deg]" />
                        Lost Leads
                      </td>
                      <td className="text-[20px] font-semibold text-right p-2">
                        {leadStats?.totalLostLeads}
                      </td>
                    </tr>

                    <tr className="bg-gradient-to-r cursor-pointer from-yellow-100 to-yellow-50 text-yellow-800 border border-yellow-200 rounded-md shadow mb-2">
                      <td className="flex items-center p-2 col-span-2 font-semibold">
                        <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-yellow-200 text-yellow-600 mr-2 rotate-[-90deg]" />
                        Followup Leads
                      </td>
                      <td className="text-[20px] font-semibold text-right p-2">
                        {leadStats?.totalFollowupLeads}
                      </td>
                    </tr>
                  </>
                )}






                <tr className=" bg-white border-l-4 border-blue-500 rounded-md shadow mb-2">
                  <td className="flex items-center p-3  font-semibold rounded-l-md">

                    Today Leads
                  </td>
                  <td className="text-[20px] font-bold text-gray-700 text-right p-3">
                    {leadStats?.todayLeads}
                  </td>


                </tr>
                <tr className="bg-white border-l-4 border-purple-500 rounded-md shadow mb-2">
                  <td className="flex items-center p-2 col-span-2 font-semibold">

                    Future Leads
                  </td>
                  <td className="text-[20px] font-semibold text-right p-2">
                    {leadStats?.futureLeads}
                  </td>


                </tr>

                <tr className="bg-white border-l-4 border-red-500  rounded-md shadow mb-2">
                  <td className="flex items-center p-3 text-gray-800 font-semibold rounded-l-md">

                    UnFollow-up Leads
                  </td>
                  <td className="text-[20px] font-bold text-gray-700 text-right p-3">
                    {leadStats?.unfollowLeads}
                  </td>
                  {/* <td className="text-[20px] font-bold text-green-700 text-right p-3 rounded-r-md">
                      ₹ {allQuotationDatas.quotationSendValue}
                    </td> */}

                </tr>
              </tbody>
            </table>
          </div>

          <HeaderWithButton
            title="Lead"
            description="lead"
            buttonText="Lead"
            onButtonClick={handleAddLead}
          // showButton={leadPermission}
          />

          {/* Top filters */}

          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 items-end mt-4">
            {/* Date filter */}

            {/* salesman Dropdown */}
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Sales Person
              </label>
              <Select
                name="salesman_tally_id"
                options={salesmanData?.map((cust) => ({
                  value: cust?.salesman_tally_id,
                  label: cust?.name,
                }))}
                value={
                  salesmanData
                    ?.map((cust) => ({
                      value: cust?.salesman_tally_id,
                      label: cust?.name,
                    }))
                    .find(
                      (cust) => cust?.value === topFilter?.salesman_tally_id
                    ) || null
                }
                onChange={(selectedOption) =>
                  handleChangeForLeadFilter({
                    target: {
                      name: "salesman_tally_id",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                isDisabled={isEditing}
                isMulti={false}
                isClearable={true}
                placeholder="Select Person "
                className="react-select-container"
                classNamePrefix="select"
              />
            </div>

            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Project Manager
              </label>
              <Select
                name="project_manager"
                options={projectManagerList?.map((cust) => ({
                  value: cust?.name,
                  label: cust?.name,
                }))}
                value={
                  projectManagerList
                    ?.map((cust) => ({
                      value: cust?.name,
                      label: cust?.name,
                    }))
                    .find(
                      (cust) => cust.value === topFilter?.project_manager
                    ) || null
                }
                onChange={(selectedOption) =>
                  handleChangeForLeadFilter({
                    target: {
                      name: "project_manager",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                isDisabled={isEditing}
                isMulti={false}
                isClearable={true}
                placeholder="Select Project Manager"
                className="react-select-container"
                classNamePrefix="select"
              />
            </div>

            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Labour Name
              </label>
              <Select
                name="worker_tally_id"
                options={workersData?.map((cust) => ({
                  value: cust?.worker_tally_id,
                  label: cust?.name,
                }))}
                value={
                  workersData
                    ?.map((cust) => ({
                      value: cust?.worker_tally_id,
                      label: cust?.name,
                    }))
                    .find(
                      (cust) => cust?.value === topFilter?.worker_tally_id
                    ) || null
                }
                onChange={(selectedOption) =>
                  handleChangeForLeadFilter({
                    target: {
                      name: "worker_tally_id",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                isDisabled={isEditing}
                isMulti={false}
                isClearable={true}
                placeholder="Select Labour Name "
                className="react-select-container"
                classNamePrefix="select"
              />
            </div>
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Type of Work
              </label>
              {/* <Select
                name="type_of_work"
                options={typeOfWork?.map((work) => ({
                  value: work.id,
                  label: work.name,
                }))}
                value={
                  // Find the option where option.value matches topFilter.type_of_work
                  typeOfWork
                    ?.map((work) => ({ value: work.id, label: work.name }))
                    .find(
                      (option) => option.value === topFilter.type_of_work
                    ) || null
                }
                onChange={(selectedOption) =>
                  handleChangeForLeadFilter({
                    target: {
                      name: "type_of_work",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                isDisabled={isEditing}
                isMulti={false}
                isClearable={true}
                placeholder="Select Type of Work"
                className="react-select-container"
                classNamePrefix="select"
              /> */}
              <Select
                name="type_of_work"
                options={typeOfWork?.map((work) => ({
                  value: work.id, // id
                  label: work.name, // name
                }))}
                value={
                  typeOfWork
                    ?.map((work) => ({ value: work.id, label: work.name }))
                    .find(
                      (option) => option.value === topFilter.type_of_work
                    ) || null
                }
                onChange={(selectedOption) =>
                  handleChangeForLeadFilter({
                    target: {
                      name: "type_of_work",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                isDisabled={isEditing}
                isMulti={false}
                isClearable={true}
                placeholder="Select Type of Work"
                className="react-select-container"
                classNamePrefix="select"
              />
            </div>

            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Sales / Service
              </label>
              <Select
                name="sales_service"
                options={salesServiceOptions?.map((item) => ({
                  value: item.value,
                  label: item.name,
                }))}
                value={
                  salesServiceOptions
                    ?.map((item) => ({
                      value: item.value,
                      label: item.name,
                    }))
                    .find(
                      (option) => option.value === topFilter.sales_service
                    ) || null
                }
                onChange={(selectedOption) =>
                  handleChangeForLeadFilter({
                    target: {
                      name: "sales_service",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                isDisabled={isEditing}
                isMulti={false}
                isClearable={true}
                placeholder="Select Sales / Service"
                className="react-select-container"
                classNamePrefix="select"
              />
            </div>

            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Status
              </label>
              <Select
                name="lead_status"
                options={statusOptions?.map((item) => ({
                  value: item.value,
                  label: item.name,
                }))}
                value={
                  statusOptions
                    ?.map((item) => ({
                      value: item.value,
                      label: item.name,
                    }))
                    .find((option) => option.value == topFilter.lead_status) ||
                  null
                }
                onChange={(selectedOption) =>
                  handleChangeForLeadFilter({
                    target: {
                      name: "lead_status",
                      value: selectedOption?.value || "",
                    },
                  })
                }
                isDisabled={isEditing}
                isMulti={false}
                isClearable={true}
                placeholder="Select Status"
                className="react-select-container"
                classNamePrefix="select"
              />
            </div>

            <div className="space-y-3 ">
              {/* PO Date Select */}
              <div className="">
                <label className="block text-sm font-medium">
                  Next follow up date
                </label>
                <select
                  name="date_filter"
                  value={filters.date_filter}
                  onChange={handleDateFilterChange}
                  className="border border-gray-300 p-2 rounded w-full mt-2"
                >
                  <option value="" className="text-gray-300">
                    -- Select --
                  </option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                  <option value="this_year">This Year</option>
                  <option value="custom">Custom Range</option>
                </select>
              </div>
            </div>

            <div className="space-y-3 ">
              {/* PO Date Select */}
              <div className="">
                <label className="block text-sm font-medium">Create date</label>
                <select
                  name="create_date_filter"
                  value={filters.create_date_filter}
                  onChange={handleDateFilterChange}
                  className="border border-gray-300 p-2 rounded w-full mt-2"
                >
                  <option value="" className="text-gray-300">
                    -- Select --
                  </option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                  <option value="this_year">This Year</option>
                  <option value="custom">Custom Range</option>
                </select>
              </div>
            </div>
          </div>

          <div className="w-full">
            {filters.create_date_filter === "custom" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700">
                    Create Date From
                  </label>
                  <input
                    type="date"
                    name="create_date_from"
                    id="create_date_from"
                    onClick={() =>
                      document.getElementById("create_date_from").showPicker()
                    }
                    value={filters.create_date_from}
                    onChange={handleDateFilterChange}
                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                  />
                </div>
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700">
                    Create Date To
                  </label>
                  <input
                    type="date"
                    name="create_date_to"
                    id="create_date_to"
                    onClick={() =>
                      document.getElementById("create_date_to").showPicker()
                    }
                    value={filters.create_date_to}
                    onChange={handleDateFilterChange}
                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                  />
                </div>
              </div>
            )}
          </div>

          <div className="w-full">
            {filters.date_filter === "custom" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700">
                    Date From
                  </label>
                  <input
                    type="date"
                    name="date_from"
                    id="date_from"
                    onClick={() =>
                      document.getElementById("date_from").showPicker()
                    }
                    value={filters.date_from}
                    onChange={handleDateFilterChange}
                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                  />
                </div>
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700">
                    Date To
                  </label>
                  <input
                    type="date"
                    name="date_to"
                    id="date_to"
                    onClick={() =>
                      document.getElementById("date_to").showPicker()
                    }
                    value={filters.date_to}
                    onChange={handleDateFilterChange}
                    className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                  />
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-4 mt-4">
            {/* Submit Button */}
            <button
              ref={submitBtnRef}
              onClick={handleSubmitFilter}
              // onClick={handleSubmitCustomFilter}
              className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
            >
              Submit
            </button>

            {/* Reset Button */}
            <button
              onClick={handleResetTopFilter}
              className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
            >
              Reset
            </button>

            <button
              onClick={handleDownloadPDF}
              className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
            >
              PDF
            </button>

            <button
              onClick={handleDownloadExcel}
              className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
            >
              Excel
            </button>
          </div>

          <LeadList
            setOpenDialogBoxForLead={setOpenDialogBoxForLead}
            setLeadDetails={setLeadDetails}
            setSaveBtn={setSaveBtn}
            setLoading={setLoading}
            leadPaginationData={leadPaginationData}
            setEditId={setEditId}
            fetchLeadDatas={fetchLeadDatas}
            setIsEditing={setIsEditing}
            setSaveBtnOpen={setSaveBtnOpen}
            setEditLeadIdCrypty={setEditLeadIdCrypty}
            id_crypt={id_crypt}
            showForm={showForm}
            filterParams={filterParams}
            leadDetails={leadDetails}
            setRequiredFields={setRequiredFields}
            setLeadDiscussion={setLeadDiscussion}
            leadDiscussion={leadDiscussion}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            // Lead={Lead}
            fetchLeadOnly={fetchLeadOnly}
            topFilter={topFilter}
            setPreviewImages={setPreviewImages}
            setExistingImages={setExistingImages}
            setDeletedImages={setDeletedImages}
            leadStatusState={leadStatusState}
            unFollowedTypeOfWorkFilter={unFollowedTypeOfWorkFilter}
            setLeadPhoneData={setLeadPhoneData}

          />
          {openDialogBoxForLead && (
            <Dialog
              open={openDialogBoxForLead}
              onClose={() => { }}
              className="relative z-10"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto ">
                    <div
                      className="flex justify-between p-4 text-white sticky top-0 z-50"
                      style={{ backgroundColor: "#6366f1" }}
                    >
                      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium uppercase ">
                        Lead Management
                      </h1>
                      <div className="flex gap-2">
                        {isEditing && (
                          <div className="relative">
                            <button
                              type="button"
                              className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900"
                              aria-expanded={isOpenEdit}
                            >
                              <PencilSquareIcon
                                // onClick={() => setIsOpenEdit(!isOpenEdit)} // Toggle visibility
                                onClick={() => {
                                  handleEditForLead(editLeadIdCrypty);
                                  setIsOpenEdit(false);
                                }}
                                className="h-6 w-6 cursor-pointer text-white"
                              />
                            </button>

                            {isOpenEdit && (
                              <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                                <div className="w-56 shrink rounded-xl bg-white p-4 text-sm/6 font-semibold text-gray-900 ring-1 shadow-lg ring-gray-900/5">
                                  <a
                                    href="#"
                                    className="block p-2 hover:text-indigo-600"
                                    onClick={() => {
                                      handleEditForLead(editLeadIdCrypty);
                                      setIsOpenEdit(false);
                                    }}
                                  >
                                    Edit
                                  </a>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        <XMarkIcon
                          onClick={handleDialogClose}
                          className="h-6 w-6 cursor-pointer"
                        />
                      </div>
                    </div>

                    <div className="md:grid md:gap-6 p-4">
                      <div className="md:mt-0 md:col-span-2">
                        <form className="rounded-lg shadow-xl bg-white p-6 space-y-8">
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {/* Customer Name */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Party / Company Name
                                <span className="text-red-600">*</span>
                              </label>
                              {/* <input
                                type="text"
                                name="customer_name"
                                value={leadDetails?.customer_name}
                                onChange={handleChangeForPartyName}
                                placeholder="Name"
                                disabled={isEditing}
                                className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                  }`}
                              /> */}

                              <div className="relative">
                                <input
                                  type="text"
                                  name="customer_name"
                                  value={leadDetails?.customer_name || ""}
                                  onChange={handleChangeForPartyName}
                                  placeholder="Name"
                                  disabled={isEditing}
                                  autoComplete="off"
                                  className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                    }`}
                                />

                                {showSuggestions && partyName.length > 0 && (
                                  <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-auto">
                                    {partyName.map((item, index) => (
                                      <li
                                        key={index}
                                        onClick={() => handleSelectSuggestion(item)}
                                        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                      >
                                        {item.ledger_name}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>



                              {requiredFields?.customer_name && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.customer_name}
                                </p>
                              )}
                            </div>
                            {/* Phone */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Mobile No <span className="text-red-600">*</span>
                              </label>
                              {/* <input
                                type="number"
                                name="contact_no"
                                value={leadDetails?.contact_no}
                                onChange={handleChangeForLead}
                                placeholder="Phone"
                                disabled={isEditing}
                                className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${
                                  isEditing ? "bg-gray-100" : ""
                                }`}
                              /> */}
                              <input
                                type="text"
                                name="contact_no"
                                value={leadDetails?.contact_no}
                                onChange={(e) => {
                                  const digitsOnly = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  ); // remove all non-digit characters
                                  handleChangeForLead({
                                    target: {
                                      name: "contact_no",
                                      value: digitsOnly,
                                    },
                                  });
                                }}
                                placeholder="Phone"
                                disabled={isEditing}
                                className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                  }`}
                              />
                              {requiredFields?.contact_no && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.contact_no}
                                </p>
                              )}
                            </div>
                            {/* Type of Work */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Type of Work
                                <span className="text-red-600"> *</span>
                              </label>
                              <Select
                                name="type_of_work"
                                options={typeOfWork?.map((type) => ({
                                  value: type.name,
                                  label: type.name,
                                }))}
                                value={
                                  typeOfWork
                                    ?.filter((type) =>
                                      leadDetails?.type_of_work?.includes(
                                        type.name
                                      )
                                    )
                                    .map((type) => ({
                                      value: type.name,
                                      label: type.name,
                                    })) || []
                                }
                                onChange={(selectedOptions) =>
                                  handleChangeForLead({
                                    target: {
                                      name: "type_of_work",
                                      value:
                                        selectedOptions?.map(
                                          (opt) => opt.value
                                        ) || [],
                                    },
                                  })
                                }
                                isDisabled={isEditing}
                                isMulti={true}
                                isClearable={true}
                                placeholder="Select Type of Work"
                                className="mt-1"
                                classNamePrefix="select"
                              />
                              {requiredFields?.type_of_work && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.type_of_work}
                                </p>
                              )}
                            </div>

                            {/* Sales / Service */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Sales / Service
                                <span className="text-red-600"> *</span>
                              </label>
                              <Select
                                name="sales_service"
                                options={[
                                  { value: "Sales", label: "Sales" },
                                  { value: "Service", label: "Service" },
                                ]}
                                value={
                                  leadDetails?.sales_service
                                    ? {
                                      value: leadDetails.sales_service,
                                      label:
                                        leadDetails.sales_service === "Sales"
                                          ? "Sales"
                                          : "Service",
                                    }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleChangeForLead({
                                    target: {
                                      name: "sales_service",
                                      value: selectedOption?.value || "",
                                    },
                                  })
                                }
                                isDisabled={isEditing}
                                isMulti={false}
                                isClearable={true}
                                placeholder="Select Sales or Service"
                                className="mt-1"
                                classNamePrefix="select"
                              />
                              {requiredFields?.sales_service && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.sales_service}
                                </p>
                              )}
                            </div>

                            {/* Workers */}
                            {(userId === 1 || userId === 2) && (
                              <>
                                <div>
                                  <label className="block text-sm font-medium text-gray-700">
                                    Labour
                                    <span className="text-red-600"> *</span>
                                  </label>
                                  <Select
                                    name="worker_tally_id"
                                    options={workers?.map((worker) => ({
                                      value: worker.id,
                                      label: worker.name,
                                    }))}
                                    value={
                                      workers
                                        ?.map((worker) => ({
                                          value: worker.id,
                                          label: worker.name,
                                        }))
                                        .find(
                                          (worker) =>
                                            worker.value ==
                                            leadDetails?.worker_tally_id
                                        ) || null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChangeForLead({
                                        target: {
                                          name: "worker_tally_id",
                                          value: selectedOption?.value || "",
                                          worker: selectedOption?.label || "",
                                        },
                                      })
                                    }
                                    isDisabled={isEditing}
                                    isMulti={false}
                                    isClearable={true}
                                    placeholder="Select Labour"
                                    className="mt-1"
                                    classNamePrefix="select"
                                  />

                                  {requiredFields?.worker_tally_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields?.worker_tally_id}
                                    </p>
                                  )}
                                </div>

                                <div>
                                  <label className="block text-sm font-medium text-gray-700">
                                    Sales Person
                                    <span className="text-red-600"> *</span>
                                  </label>
                                  <Select
                                    name="salesman_tally_id"
                                    options={salesMan?.map((sales) => ({
                                      value: sales.id,
                                      label: sales.name,
                                    }))}
                                    value={
                                      salesMan
                                        ?.map((sales) => ({
                                          value: sales.id,
                                          label: sales.name,
                                        }))
                                        .find(
                                          (sales) =>
                                            sales.value ==
                                            leadDetails?.salesman_tally_id
                                        ) || null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChangeForLead({
                                        target: {
                                          name: "salesman_tally_id",
                                          value: selectedOption?.value || "",
                                          salesman: selectedOption?.label || "",
                                        },
                                      })
                                    }
                                    isDisabled={isEditing}
                                    isMulti={false}
                                    isClearable={true}
                                    placeholder="Select Sales Person"
                                    className="mt-1"
                                    classNamePrefix="select"
                                  />
                                  {requiredFields?.salesman_tally_id && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields?.salesman_tally_id}
                                    </p>
                                  )}
                                </div>

                                <div>
                                  <label className="block text-sm font-medium text-gray-700">
                                    Project Manager
                                    <span className="text-red-600"> *</span>
                                  </label>
                                  <Select
                                    name="project_manager"
                                    options={projectManager?.map((sales) => ({
                                      value: sales.name,
                                      label: sales.name,
                                    }))}
                                    value={
                                      projectManager
                                        ?.map((sales) => ({
                                          value: sales.name,
                                          label: sales.name,
                                        }))
                                        .find(
                                          (sales) =>
                                            sales.value ==
                                            leadDetails?.project_manager
                                        ) || null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChangeForLead({
                                        target: {
                                          name: "project_manager",
                                          value: selectedOption?.value || "",
                                          projectManager:
                                            selectedOption?.value || "",
                                        },
                                      })
                                    }
                                    isDisabled={isEditing}
                                    isMulti={false}
                                    isClearable={true}
                                    placeholder="Select Project Manager"
                                    className="mt-1"
                                    classNamePrefix="select"
                                  />
                                  {requiredFields?.project_manager && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields?.project_manager}
                                    </p>
                                  )}
                                </div>
                              </>
                            )}

                            {/* Follup Status */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Lead Status
                                <span className="text-red-600"> *</span>
                              </label>
                              <Select
                                name="lead_status"
                                options={leadStatus?.map((status) => ({
                                  value: status.id,
                                  label: status.label,
                                }))}
                                value={
                                  leadStatus
                                    ?.map((status) => ({
                                      value: status.id,
                                      label: status.label,
                                    }))
                                    .find(
                                      (status) =>
                                        status.value ===
                                        leadDetails?.lead_status
                                    ) || null
                                }
                                onChange={(selectedOption) =>
                                  handleChangeForLead({
                                    target: {
                                      name: "lead_status",
                                      value: selectedOption?.value || "",
                                    },
                                  })
                                }
                                isDisabled={isEditing}
                                isMulti={false}
                                isClearable={true}
                                placeholder="Select Status"
                                className="mt-1"
                                classNamePrefix="select"
                              />
                              {requiredFields?.lead_status && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.lead_status}
                                </p>
                              )}
                            </div>

                            {/* show Reason */}
                            {leadDetails.lead_status === "loss" && (
                              <div>
                                <label className="block text-sm font-medium text-gray-700">
                                  Lost Reason
                                  <span className="text-red-600"> *</span>
                                </label>
                                <Select
                                  name="loss_reason"
                                  options={lossReason?.map((reason) => ({
                                    value: reason.id,
                                    label: reason.reason,
                                  }))}
                                  value={
                                    lossReason
                                      ?.map((reason) => ({
                                        value: reason.id,
                                        label: reason.reason,
                                      }))
                                      .find(
                                        (reason) =>
                                          reason.value ==
                                          leadDetails?.loss_reason
                                      ) || null
                                  }
                                  onChange={(selectedOption) =>
                                    handleChangeForLead({
                                      target: {
                                        name: "loss_reason",
                                        value: selectedOption?.value || "",
                                        worker: selectedOption?.label || "",
                                      },
                                    })
                                  }
                                  isDisabled={isEditing}
                                  isMulti={false}
                                  isClearable={true}
                                  placeholder="Select Loss Reason"
                                  className="mt-1"
                                  classNamePrefix="select"
                                />

                                {requiredFields?.loss_reason && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.loss_reason}
                                  </p>
                                )}
                              </div>
                            )}

                            {/* Follow up date */}
                            {leadDetails.lead_status === "followup" && (
                              <div>
                                <label className="block text-sm font-medium text-gray-700">
                                  Follow Up Date
                                  <span className="text-red-600"> *</span>
                                </label>
                                <input
                                  type="date"
                                  name="followup_date"
                                  min={new Date().toISOString().split("T")[0]}
                                  value={leadDetails?.followup_date || ""}
                                  onChange={handleChangeForLead}
                                  className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                    }`}
                                  disabled={isEditing}
                                />

                                {requiredFields?.followup_date && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.followup_date}
                                  </p>
                                )}
                              </div>
                            )}

                            {/* Advertisement Mode */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Advertisement Mode
                                {/* <span className="text-red-600"> *</span> */}
                              </label>
                              <Select
                                name="advertisement_mode_id"
                                options={advertisementMode?.map((type) => ({
                                  value: type.id,
                                  label: type.name,
                                }))}
                                //  value={
                                //   advertisementMode
                                //     ?.map((status) => ({
                                //       value: status.id,
                                //       label: status.label,
                                //     }))
                                //     .find(
                                //       (status) =>
                                //         status.value ==
                                //         leadDetails?.advertisement_mode_id
                                //     ) || null
                                // }
                                value={
                                  leadDetails?.advertisement_mode_id && {
                                    value: leadDetails.advertisement_mode_id,
                                    label:
                                      advertisementMode?.find(
                                        (mode) =>
                                          mode.id ===
                                          leadDetails.advertisement_mode_id
                                      )?.name || "",
                                  }
                                  // : advertisementMode
                                  //     ?.filter(
                                  //       (mode) =>
                                  //         mode.name === "SUKUMAR - PHONE CALL"
                                  //     )
                                  //     .map((mode) => ({
                                  //       value: mode.id,
                                  //       label: mode.name,
                                  //     }))[0] || null
                                }
                                // value={leadDetails?.advertisement_mode_id}
                                onChange={(selectedOption) =>
                                  handleChangeForLead({
                                    target: {
                                      name: "advertisement_mode_id",
                                      value: selectedOption?.value || "",
                                    },
                                  })
                                }
                                isDisabled={isEditing}
                                isMulti={false}
                                isClearable={true}
                                placeholder="Select Advertisement Mode"
                                className="mt-1"
                                classNamePrefix="select"
                              />
                              {requiredFields?.advertisement_mode_id && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.advertisement_mode_id}
                                </p>
                              )}
                            </div>

                            {/* Contact Person */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Contact Person
                              </label>
                              <input
                                type="text"
                                name="contact_person"
                                value={leadDetails?.contact_person || ""}
                                onChange={handleChangeForLead}
                                placeholder="Contact Person"
                                disabled={isEditing}
                                className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                  }`}
                              />
                              {requiredFields?.contact_person && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.contact_person}
                                </p>
                              )}
                            </div>

                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Contact Person no
                              </label>
                              <input
                                type="number"
                                name="contact_person_no"
                                value={leadDetails?.contact_person_no}
                                onChange={handleChangeForLead}
                                placeholder="Contact Person Number"
                                disabled={isEditing}
                                className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                  }`}
                              />
                              {requiredFields?.contact_person_no && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.contact_person_no}
                                </p>
                              )}
                            </div>

                            {/* <div>
                              <label className="block text-sm font-medium text-gray-700">
                                City / Town
                              </label>
                              <input
                                type="text"
                                name="city"
                                value={leadDetails?.city || ""}
                                onChange={handleChangeForLead}
                                placeholder="City"
                                disabled={isEditing}
                                className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${
                                  isEditing ? "bg-gray-100" : ""
                                }`}
                              />
                              {requiredFields?.city && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.city}
                                </p>
                              )}
                            </div> */}
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                City / Town
                              </label>
                              <Select
                                name="city"
                                options={cities?.map((city) => ({
                                  value: city.name, // Sending name as value
                                  label: city.name,
                                }))}
                                value={
                                  leadDetails?.city && {
                                    value: leadDetails.city,
                                    label:
                                      cities.find(
                                        (city) => city.name === leadDetails.city
                                      )?.name || "",
                                  }
                                }
                                onChange={(selectedOption) =>
                                  handleChangeForLead({
                                    target: {
                                      name: "city",
                                      value: selectedOption?.value || "",
                                    },
                                  })
                                }
                                isDisabled={isEditing}
                                isMulti={false}
                                isClearable={true} // ✅ This enables deselect (clear button)
                                placeholder="Select City / Town"
                                className="mt-1"
                                classNamePrefix="select"
                              />
                            </div>

                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Priority
                              </label>

                              <Select
                                name="priority"
                                options={priority?.map((reason) => ({
                                  value: reason.priority,
                                  label: reason.priority,
                                }))}
                                value={
                                  priority
                                    ?.map((reason) => ({
                                      value: reason.priority,
                                      label: reason.priority,
                                    }))
                                    .find(
                                      (reason) =>
                                        reason.value == leadDetails?.priority
                                    ) || null
                                }
                                onChange={(selectedOption) =>
                                  handleChangeForLead({
                                    target: {
                                      name: "priority",
                                      value: selectedOption?.value || "",
                                      worker: selectedOption?.label || "",
                                    },
                                  })
                                }
                                isDisabled={isEditing}
                                isMulti={false}
                                isClearable={true}
                                placeholder="Select Priority"
                                className="mt-1"
                                classNamePrefix="select"
                              />

                            </div>

                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Location
                              </label>
                              <input
                                type="text"
                                name="location"
                                value={leadDetails?.location}
                                onChange={handleChangeForLead}
                                placeholder="Location"
                                disabled={isEditing}
                                className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                  }`}
                              />
                              {requiredFields?.location && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields?.location}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Address Section */}
                          <div>
                            {/* <h2 className="text-lg font-semibold text-gray-800 mt-4 mb-2">
                              Address Details
                            </h2> */}
                            <div className="grid grid-cols-2 gap-6">
                              <div>
                                <label className="block text-sm font-medium text-gray-700">
                                  Address
                                </label>
                                <textarea
                                  name="address"
                                  placeholder="Address"
                                  rows={3}
                                  value={leadDetails?.address}
                                  onChange={handleChangeForLead}
                                  disabled={isEditing}
                                  className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                    }`}
                                />
                                {requiredFields?.address && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.address}
                                  </p>
                                )}
                              </div>
                              {/* </div>

                            <div className="grid grid-cols-1 gap-6"> */}
                              <div>
                                <label className="block text-sm font-medium text-gray-700">
                                  Comments
                                </label>
                                <textarea
                                  name="comments"
                                  placeholder="Comments"
                                  rows={3}
                                  value={leadDetails?.comments}
                                  onChange={handleChangeForLead}
                                  disabled={isEditing}
                                  className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${isEditing ? "bg-gray-100" : ""
                                    }`}
                                />
                                {requiredFields?.comments && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.comments}
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* Country, State */}
                            {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
                              <div>
                                <label className="block text-sm font-medium text-gray-700">
                                  Country
                                </label>
                                <input
                                  type="text"
                                  name="country"
                                  value={leadDetails?.country || ""}
                                  onChange={handleChangeForLead}
                                  placeholder="Country"
                                  disabled={isEditing}
                                  className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${
                                    isEditing ? "bg-gray-100" : ""
                                  }`}
                                />
                                {requiredFields?.country && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.country}
                                  </p>
                                )}
                              </div>

                              <div>
                                <label className="block text-sm font-medium text-gray-700">
                                  State
                                </label>
                                <input
                                  type="text"
                                  name="state"
                                  value={leadDetails?.state || ""}
                                  onChange={handleChangeForLead}
                                  placeholder="State"
                                  disabled={isEditing}
                                  className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm ${
                                    isEditing ? "bg-gray-100" : ""
                                  }`}
                                />
                                {requiredFields?.state && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.state}
                                  </p>
                                )}
                              </div>
                            </div> */}

                            {/* City, Pincode */}
                            {/* <div className="grid grid-cols-1  gap-6 mt-4">
                              <label className="block text-sm font-medium text-gray-700">
                                Upload Image
                              </label>
                              <input
                                type="file"
                                name="image"
                                accept="image/*"
                                onChange={handleChangeForLeadImage}
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                              />

                              {leadDetails.image && (
                                <img
                                  src={
                                    axios.defaults.baseURL + leadDetails.image
                                  }
                                  alt="Preview"
                                  className="mt-4 w-32 h-32 object-cover rounded-md"
                                />
                              )}
                            </div> */}
                            <div className="grid grid-cols-1 gap-6 mt-4">
                              <label className="block text-sm font-medium text-gray-700">
                                Upload Image
                              </label>
                              <input
                                type="file"
                                name="images"
                                accept="image/*"
                                onChange={handleChangeForLeadImages}
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                                multiple
                                disabled={isEditing}
                              />

                              <div className="mt-4 flex gap-4 flex-wrap">
                                {/* ✅ Existing images from DB */}
                                {existingImages?.map((img, index) => (
                                  <div
                                    key={`existing-${index}`}
                                    className="relative"
                                  >
                                    <img
                                      src={
                                        axios.defaults.baseURL + "/" + img.image
                                      }
                                      alt={`Existing ${index}`}
                                      className="w-32 h-32 object-cover rounded-md"
                                    />
                                    {!isEditing && (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveImage(index, true)
                                        }
                                        className="absolute top-1 right-1 bg-red-500 text-white text-xs px-2 py-1 rounded"
                                      >
                                        ✕
                                      </button>
                                    )}
                                  </div>
                                ))}

                                {/* ✅ Newly uploaded images (File objects) */}
                                {leadDetails?.images?.map((file, index) => (
                                  <div
                                    key={`new-${index}`}
                                    className="relative"
                                  >
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt={`New ${index}`}
                                      className="w-32 h-32 object-cover rounded-md"
                                    />

                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleRemoveImage(index, false)
                                      }
                                      className="absolute top-1 right-1 bg-red-500 text-white text-xs px-2 py-1 rounded"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                ))}
                              </div>
                              {/* {previewImages?.length > 0 && (
                                <div className="mt-4 flex gap-4 flex-wrap">
                                  {previewImages.map((src, index) => (
                                    <div key={index} className="relative">
                                     
                                      {saveBtn === "save" && saveBtnOpen ? (
                                        <img
                                          src={src}
                                          alt={`Preview ${index}`}
                                          className="w-32 h-32 object-cover rounded-md"
                                        />
                                      ) : (
                                        <img
                                          src={axios.defaults.baseURL + src}
                                          alt={`Preview ${index}`}
                                          className="w-32 h-32 object-cover rounded-md"
                                        />
                                      )}

                                      <button
                                        type="button"
                                        onClick={() => handleRemoveImage(index)}
                                        className="absolute top-1 right-1 bg-red-500 text-white text-xs px-2 py-1 rounded"
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )} */}
                            </div>
                          </div>

                          {/* <div class="p-2 m-2 bg-gray-50 border shadow sm:rounded-xl max-w-8xl">
                            <div
                              onClick={() => setLeadPhoneDataFlag(!leadPhoneDataFlag)}
                              className="flex items-center justify-between cursor-pointer"
                            >
                              <h2 className="text-md font-semibold    text-gray-800 flex items-center gap-2">
                                <DevicePhoneMobileIcon  className="h-5 w-5 text-gray-500" />
                                <span>Customer Phone</span>
                              </h2>
                              {leadPhoneDataFlag ? (
                                <ChevronUpIcon className="h-5 w-5 text-gray-500" />
                              ) : (
                                <ChevronDownIcon className="h-5 w-5 text-gray-500" />
                              )}
                            </div>
                                {leadPhoneDataFlag && (
                                  
                                    <div>
                                          {leadPhoneData.ledger_name}
                                    </div>
                                )}
                            
                          </div> */}

                          {/* <div className="p-4 bg-white border rounded-xl shadow-sm ">
                       
                            <div
                              onClick={() =>
                                setLeadPhoneDataFlag(!leadPhoneDataFlag)
                              }
                              className="flex items-center justify-between cursor-pointer"
                            >
                              <div className="flex items-center gap-3">
                                <div className="p-2 bg-gray-100 rounded-lg">
                                  <DevicePhoneMobileIcon className="h-5 w-5 text-gray-600" />
                                </div>
                                <h2 className="text-lg font-semibold text-gray-800">
                                  Party Details
                                </h2>
                              </div>

                              {leadPhoneDataFlag ? (
                                <ChevronUpIcon className="h-5 w-5 text-gray-600" />
                              ) : (
                                <ChevronDownIcon className="h-5 w-5 text-gray-600" />
                              )}
                            </div>

                            {leadPhoneDataFlag && (
                              <div className="mt-4 p-4 bg-gray-50 rounded-lg border space-y-3">
                                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Party Name
                                    </p>
                                    <p className="font-medium text-gray-900">
                                      {leadPhoneData?.ledger_name ?? "—"}
                                    </p>
                                  </div>

                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Ledger Group
                                    </p>
                                    <p className="font-medium text-gray-900">
                                      {leadPhoneData?.ledger_group ?? "—"}
                                    </p>
                                  </div>

                                  <div>
                                    <p className="text-xs text-gray-500">
                                      Mobile No
                                    </p>
                                    <p className="font-medium text-gray-900">
                                      {leadPhoneData?.primary_mobile_no ?? "—"}
                                    </p>
                                  </div>

                                  <div>
                                    <p className="text-xs text-gray-500">
                                      State
                                    </p>
                                    <p className="font-medium text-gray-900">
                                      {leadPhoneData?.state ?? "—"}
                                    </p>
                                  </div>
                                </div>

                              
                                <div>
                                  <p className="text-xs text-gray-500">
                                    Address
                                  </p>
                                  <p className="font-medium text-gray-900">
                                    {[
                                      leadPhoneData?.address_line_1,
                                      leadPhoneData?.address_line_2,
                                      leadPhoneData?.address_line_3,
                                    ]
                                      .filter(Boolean)
                                      .join(", ") || "—"}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div> */}

                          {/* Submit / Update Button */}
                          <div className="flex justify-end pt-4">
                            {saveBtn === "save" && saveBtnOpen ? (
                              <button
                                onClick={handleSubmitForLead}
                                className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            ) : saveBtnOpen ? (
                              <UpdateConfirmation
                                id_crypt={editLeadIdCrypty}
                                apiType="lead"
                                fetchClientData={fetchLeadOnly}
                                inputs={leadDetails}
                                deletedImages={deletedImages}
                                setOpenDialogBoxForLead={
                                  setOpenDialogBoxForLead
                                }
                              />
                            ) : null}
                          </div>
                        </form>
                      </div>
                    </div>
                  </Dialog.Panel>
                </div>
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}

export default LeadCreate;
